import React, { useCallback, useRef, useState } from 'react';
import cx from 'classnames';
import { ReactComponent as Scale } from '../../assets/img/icons/header/Scale.svg';
import { ReactComponent as CaretDown } from '../../assets/img/icons/header/CaretDown.svg';
import { useHandleOutsideClick } from '../../hooks/useHandleOutsideClick';
import { weightMeasurementSystemOptions } from '../../constants/measurementUnits.constants';
import { useWeightMeasurementSystemContext } from '../../contexts/WeightMeasurementUnitsContext';

export default function HeaderUnits() {
  const containerRef = useRef(null);
  const { system, setSystem } = useWeightMeasurementSystemContext();
  const [dropdownOpened, setDropdownOpened] = useState(false);

  const onClickOutside = useCallback(() => {
    setDropdownOpened(false);
  }, []);

  useHandleOutsideClick(dropdownOpened, onClickOutside, containerRef);

  return (
    <div ref={containerRef} className="header-global__container">
      <div className="global-option__container p-0" onClick={() => setDropdownOpened(!dropdownOpened)}>
        <Scale style={{ width: '24px', height: '24px' }} />

        <div className="global-option__container-text">
          <div className="lh-base" data-toggle="tooltip" data-placement="bottom" title={system}>
            {weightMeasurementSystemOptions.find(({ value }) => value === system).label}
          </div>
        </div>

        <div className="global-option__container-icon">
          <CaretDown />
        </div>
      </div>

      {dropdownOpened && (
        <ul className="global-option__container__ul w-100">
          {weightMeasurementSystemOptions.map(opt => (
            <li
              key={opt.value}
              className={cx('navbar--option-li w-100', {
                'navbar--option-li-selected': opt.value === system,
              })}
              onClick={() => {
                setSystem(opt.value);
                setDropdownOpened(false);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
